import { login } from "../auth.js";
import { ApiError } from "../api.js";
import { navigate } from "../app.js";
import { takeReturn } from "../returnTo.js";

/** query: `email` fills in the address (see register.js). */
export function render(container, _params, query) {
  container.innerHTML = `
    <div class="auth-shell">
      <div class="card auth-card p-4">
        <div class="card-body">
          <div class="text-center mb-4">
            <img src="img/logo-mark.svg" alt="" width="56" height="56" />
            <h1 class="display-heading h3 mt-2 mb-1">DiveCohorts</h1>
            <p class="text-slate mb-0">Plan dives. Log dives. Talk about dives.</p>
          </div>
          <form id="login-form" novalidate>
            <div class="mb-3">
              <label class="form-label" for="login-email">Email</label>
              <input type="email" class="form-control" id="login-email" required />
            </div>
            <div class="mb-3">
              <label class="form-label" for="login-password">Password</label>
              <input type="password" class="form-control" id="login-password" required />
            </div>
            <div id="login-error" class="text-danger small mb-3 d-none"></div>
            <button type="submit" class="btn btn-primary w-100" id="login-submit">Log in</button>
          </form>
          <p class="text-center mt-3 mb-1"><a href="#/forgot-password">Forgot your password?</a></p>
          <p class="text-center mt-3 mb-0">
            <a href="#/register" id="login-to-register">Don't have an account? Sign up</a>
          </p>
        </div>
      </div>
    </div>`;

  const presetEmail = query?.get("email");
  if (presetEmail) {
    container.querySelector("#login-email").value = presetEmail;
    // Switching to sign up keeps it.
    container.querySelector("#login-to-register").href = `#/register?email=${encodeURIComponent(presetEmail)}`;
  }

  const form = container.querySelector("#login-form");
  const errorEl = container.querySelector("#login-error");
  const submitBtn = container.querySelector("#login-submit");

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errorEl.classList.add("d-none");
    submitBtn.disabled = true;
    submitBtn.innerHTML = `<span class="spinner-border spinner-border-sm"></span>`;
    try {
      await login(
        container.querySelector("#login-email").value.trim(),
        container.querySelector("#login-password").value
      );
      navigate(takeReturn("/feed"));
    } catch (err) {
      errorEl.textContent = err instanceof ApiError ? err.message : "Something went wrong.";
      errorEl.classList.remove("d-none");
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = "Log in";
    }
  });
}
